import HangmanGame from "../components/HangmanGame";
import FillerGame from "../components/FillerGame";
import FlashcardsGame from "../components/FlashcardsGame";
import DinoGame from "../components/DinoGame";
import MazeGame from "../components/MazeGame";
import OpsTicklesGame from "../components/OpsTicklesGame";
import ChessGame from "../components/ChessGame";
import MemoryGame from "../components/MemoryGame";
import SolitaireGame from "../components/SolitaireGame";

export const GAMES = {
  hangman: {
    id: "hangman",
    nameKey: "hangman",
    descriptionKey: "hangmanDescription",
    component: HangmanGame,
    price: 0,
    earnPoints: true,
    earnAmount: 5,
  },
  filler: {
    id: "filler",
    nameKey: "filler",
    descriptionKey: "fillerDescription",
    component: FillerGame,
    price: 0,
    earnPoints: true,
    earnAmount: 5,
  },
  flashcards: {
    id: "flashcards",
    nameKey: "flashcards",
    descriptionKey: "flashcardsDescription",
    component: FlashcardsGame,
    price: 0,
    earnPoints: true,
    earnAmount: 2,
    badgeLabel: "?",
    hideBadgeStar: true,
  },
  dino: {
    id: "dino",
    nameKey: "dinoRun",
    descriptionKey: "dinoDescription",
    component: DinoGame,
    price: 10,
    earnPoints: false,
  },
  maze: {
    id: "maze",
    nameKey: "maze",
    descriptionKey: "mazeDescription",
    component: MazeGame,
    price: 10,
    earnPoints: false,
  },
  opsTickles: {
    id: "opsTickles",
    nameKey: "opsTickles",
    descriptionKey: "opsTicklesDescription",
    component: OpsTicklesGame,
    price: 10,
    earnPoints: false,
  },
  chess: {
    id: "chess",
    nameKey: "chess",
    descriptionKey: "chessDescription",
    component: ChessGame,
    price: 0,
    earnPoints: false,
    hideBadgeStar: true,
  },
  memory: {
    id: "memory",
    nameKey: "memory",
    descriptionKey: "memoryDescription",
    component: MemoryGame,
    price: 0,
    earnPoints: false,
    hideBadgeStar: true,
  },
  solitaire: {
    id: "solitaire",
    nameKey: "solitaire",
    descriptionKey: "solitaireDescription",
    component: SolitaireGame,
    price: 0,
    earnPoints: false,
    hideBadgeStar: true,
  },
};
